import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import NewsletterSection from "../home/components/NewsletterSection";
import LRHero from "./components/LRHero";
import LRSubcategories from "./components/LRSubcategories";
import LRPostGrid from "./components/LRPostGrid";
import LRCrossLink from "./components/LRCrossLink";

export default function LivingRoom() {
  return (
    <div className="bg-[#FAF7F0] min-h-screen">
      <Navbar />
      <LRHero />
      <LRSubcategories />
      <LRPostGrid />
      <LRCrossLink />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
